const defaultMainSubdomain = 'spa'
const defaultRootDomain = 'stat.test'

export function getRootDomain() {
  return import.meta.env.VITE_ROOT_DOMAIN || defaultRootDomain
}

export function getMainSubdomain() {
  return import.meta.env.VITE_MAIN_SUBDOMAIN ?? defaultMainSubdomain
}
